export const ACTIVITY_ROUTES = {
  ACTIVITY: '/activity',
};
